// extracted by mini-css-extract-plugin
export default {"imageContainer":"imageLoader_imageContainer__14K72","loading":"imageLoader_loading__HYIGi","skeleton":"imageLoader_skeleton__pOyc9"};